import { render, staticRenderFns } from "./PageSettingsFoundationsCategories.vue?vue&type=template&id=ddf09f14&"
import script from "./PageSettingsFoundationsCategories.vue?vue&type=script&lang=js&"
export * from "./PageSettingsFoundationsCategories.vue?vue&type=script&lang=js&"
import style0 from "./PageSettingsFoundationsCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports